var $a5de891427686596$exports = {};
$a5de891427686596$exports = {
  "dragDescriptionKeyboard": "Appuyez sur Entr\xE9e pour commencer le d\xE9placement.",
  "dragDescriptionKeyboardAlt": "Appuyez sur Alt\xA0+\xA0Entr\xE9e pour commencer \xE0 faire glisser.",
  "dragDescriptionLongPress": "Appuyez de mani\xE8re prolong\xE9e pour commencer \xE0 faire glisser.",
  "dragDescriptionTouch": "Touchez deux fois pour commencer le d\xE9placement.",
  "dragDescriptionVirtual": "Cliquez pour commencer le d\xE9placement.",
  "dragItem": function dragItem(args) {
    return "D\xE9placer ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "D\xE9placer ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \xE9l\xE9ment s\xE9lectionn\xE9");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \xE9l\xE9ments s\xE9lectionn\xE9s");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Appuyez sur Entr\xE9e pour faire glisser ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \xE9l\xE9ment s\xE9lectionn\xE9");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \xE9l\xE9ments s\xE9lectionn\xE9s");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Appuyez sur Alt\xA0+\xA0Entr\xE9e pour faire glisser ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \xE9l\xE9ment s\xE9lectionn\xE9");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \xE9l\xE9ments s\xE9lectionn\xE9s");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Appuyez de mani\xE8re prolong\xE9e pour faire glisser ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \xE9l\xE9ment s\xE9lectionn\xE9");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \xE9l\xE9ments s\xE9lectionn\xE9s");
      }
    }), ".");
  },
  "dragStartedKeyboard": "D\xE9placement commenc\xE9. Appuyez sur Tabulation pour acc\xE9der \xE0 une cible de d\xE9p\xF4t, puis appuyez sur Entr\xE9e pour d\xE9poser, ou appuyez sur \xC9chap pour annuler.",
  "dragStartedTouch": "D\xE9placement commenc\xE9. Acc\xE9dez \xE0 une cible de d\xE9p\xF4t, puis touchez deux fois pour d\xE9poser.",
  "dragStartedVirtual": "D\xE9placement commenc\xE9. Acc\xE9dez \xE0 une cible de d\xE9p\xF4t, puis cliquez ou appuyez sur Entr\xE9e pour d\xE9poser.",
  "dropCanceled": "D\xE9p\xF4t annul\xE9.",
  "dropComplete": "D\xE9p\xF4t termin\xE9.",
  "dropDescriptionKeyboard": "Appuyez sur Entr\xE9e pour d\xE9poser. Appuyez sur \xC9chap pour annuler le d\xE9placement.",
  "dropDescriptionTouch": "Touchez deux fois pour d\xE9poser.",
  "dropDescriptionVirtual": "Cliquez pour d\xE9poser.",
  "dropIndicator": "indicateur de d\xE9p\xF4t",
  "dropOnItem": function dropOnItem(args) {
    return "D\xE9poser sur ".concat(args.itemText);
  },
  "dropOnRoot": "D\xE9poser sur",
  "endDragKeyboard": "D\xE9placement. Appuyez sur Entr\xE9e pour annuler le d\xE9placement.",
  "endDragTouch": "D\xE9placement. Touchez deux fois pour annuler le d\xE9placement.",
  "endDragVirtual": "D\xE9placement. Cliquez pour annuler le d\xE9placement.",
  "insertAfter": function insertAfter(args) {
    return "Ins\xE9rer apr\xE8s ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "Ins\xE9rer avant ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Ins\xE9rer entre ".concat(args.beforeItemText, " et ").concat(args.afterItemText);
  }
};
export { $a5de891427686596$exports as default };